import { Output } from 'tsickle/build/definitions/tsickle';
import { Params, ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { AdminService } from './admin.service';
import { Menu } from '../models/menu.model';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  menus: Menu[];

  @ViewChild('sidebarWrapper') sidebar: ElementRef;
  @ViewChild('contentWrapper') content: ElementRef;

  constructor(private adminService: AdminService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.subscription = this.adminService.menuChanged.subscribe(
      (menus: Menu[]) => {
        if (this.adminService.fullPageContent) {
          this.sidebar.nativeElement.className = 'hidden height-100';
          this.content.nativeElement.className = 'col-xs-12 col-sm-12 col-md-12 height-100';
          this.adminService.fullPageContent = false;
        } else {
          if (!this.adminService.hasMenu()) {
            this.sidebar.nativeElement.className = 'col-xs-1 col-sm-1 col-md-2 height-100';
            this.content.nativeElement.className = 'col-xs-11 col-sm-11 col-md-10 height-100';
          } else {
            this.sidebar.nativeElement.className = 'col-xs-2 col-sm-2 col-md-3 height-100';
            this.content.nativeElement.className = 'col-xs-10 col-sm-10 col-md-9 height-100';
          }
        }
      }
    );

    this.menus = [];
    this.adminService.loadMenu(this.menus);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts